import OverviewNotifications from './OverviewNotifications'

export default OverviewNotifications
